import React from 'react';
import TourWelcome from './TourWelcome';
import TourBanner from './TourBanner';
import TourTooltip from './TourTooltip';
import TourHighlight from './TourHighlight';
import TourButton from './TourButton';

const Tour = () => {
  return (
    <>
      <TourWelcome />
      <TourBanner />
      <TourTooltip />
      <TourHighlight />
      {/* <TourButton /> */}
    </>
  );
};

export default Tour;